import { CRBTUICSSStyle, CRBTUICSSStyleImpl } from '../crbt/crbtuicss';

export interface TunesCSSStyle extends CRBTUICSSStyle
{

}

export class  TunesCSSStyleImpl extends CRBTUICSSStyleImpl implements TunesCSSStyle
{
    getWrapperCSSStyle(): object
    {
        return {
            width:"100%",
            height:'auto',//changed
            display:'flex',
            marginTop: "0px",
            justifyContents: "center",
            flexDirection: "row",
            flexFlow: "row wrap"
        };
    }

}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/tunes/tunescss.tsx